import { render, staticRenderFns } from "./ConfirmClientDetails.vue?vue&type=template&id=084b1556"
import script from "./ConfirmClientDetails.vue?vue&type=script&lang=js"
export * from "./ConfirmClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports